import { useRouter } from 'next/router';

export const useStoreId = () => {
  const { query } = useRouter();

  return query?.store as string;
};
